import { defineMessages } from 'react-intl-next';

import { useObjectSidebarActions, PanelName } from '@confluence/object-sidebar-api';

import { AudioPanel } from '../components/panel/AudioPanel';
import { useAudioPlaybackStateActions } from '../hooks/useAudioPlaybackState';

const i18n = defineMessages({
	audioPanelTitle: {
		id: 'audio.audio-panel.title',
		defaultMessage: 'Summary Audio',
		description: 'The title for the audio panel',
	},
});

export const useShowAudioPanel = () => {
	const { showObjectSidebar } = useObjectSidebarActions();

	const { onContentStopped } = useAudioPlaybackStateActions();

	const showAudioPanel = () => {
		showObjectSidebar(
			{
				id: PanelName.AIAudioPanel,
				headerComponentElements: {
					headerLabel: i18n.audioPanelTitle,
				},
				BodyComponent: AudioPanel,
				closeOptions: {
					onPanelClose: onContentStopped,
				},
			},
			'push',
		);
	};

	return { showAudioPanel };
};
